import { SeamlyConfiguration } from '@klant/conversational-connector/klant-conversational-connector.model';

export const CONVERSATIONAL_ENVIRONMENT = 'klant-conversational.configuration';
export const CONVERSATIONAL_CHAT_DEADMANSWITCH = 'klant-conversational.chat.deadmanswitch';

export const CONVERSATIONAL_CONFIGURATION_DEFAULT: SeamlyConfiguration = {
    environment: 'Unknown',
    seamlyApiKey: '',
    seamlyApiDomain: '',
    seamlyLocalVersion: 1,
    locale: 'nl-informal'
};

export const CONVERSATIONAL_SESSION_KEY = 'mijn-conversational.chat-session';
export const MIJN_CONTACT_WEBCOMPONENT_KEY = 'mijn-contact-webcomponent';
